import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import Snotify, { SnotifyPosition } from "vue-snotify";
import router from "./router";
import underscore from './plugins/v-underscore.js';
import msal from 'vue-msal'

Vue.use(msal, {
    auth: {
      authority: 'https://login.microsoftonline.com/d4829ae2-0059-43ae-9aa2-1505407d8934/',
    clientId: '0de37472-045c-4874-b8fe-3b9aed13487e',
    redirectUri: 'https://staff.hockenbergs.com',
    requireAuthOnInitialize:true
    },
    request:{
      scopes:['api://0de37472-045c-4874-b8fe-3b9aed13487e/Users.Read']
    },
    // graph: {
    //   callAfterInit: true
    // }
});

Vue.use(underscore)

const options = {
  toast: {
    position: SnotifyPosition.centerTop,
    timeout: 1000
  },
};

Vue.use(Snotify, options);

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

const app=new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')


